var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort"},[_c('Button',{staticClass:"sort",attrs:{"icon":"el-icon-refresh"},on:{"click":_vm.sort}},[_vm._v("A-Z")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }